'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CsvExporter = function () {
  function CsvExporter() {
    _classCallCheck(this, CsvExporter);
  }

  _createClass(CsvExporter, [{
    key: 'header',
    value: function header(columns) {
      var result = '"sep=,"\r\n';
      result += this.line(columns);

      return result;
    }
  }, {
    key: 'value',
    value: function value(_value) {
      return "\"" + _value.replace(/"/g, '""') + "\"";
    }
  }, {
    key: 'line',
    value: function line(values) {
      return values.map(this.value).join(',') + '\r\n';
    }
  }, {
    key: 'export',
    value: function _export(columns, data) {
      var _this = this;

      var result = this.header(columns);

      data.forEach(function (item) {
        var values = columns.map(function (column) {
          return item.values[column] ? item.values[column] : '';
        });

        result += _this.line(values);
      });

      return result;
    }
  }]);

  return CsvExporter;
}();

exports.default = CsvExporter;


//////////////////
// WEBPACK FOOTER
// ./js/modules/report/exporters/CsvExporter.js
// module id = 28
// module chunks = 0